export default __webpack_public_path__ + "static/media/file-with-check.3c0a7d88.svg";